// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HvLk","toggleWrap":"styles_toggleWrap__24cMe","content":"styles_content__3bvJN","selectAreaCode":"styles_selectAreaCode__37EMN"};